import React, { FC, useEffect } from 'react';
import { Routes } from 'react-router-dom';
import i18next from 'i18next';
import { useDispatch } from 'react-redux';
import AxiosSetup from '~/components/AxiosSetup';
import { contentRequested } from './App.actions';
import MainLayout from '../layouts/MainLayout/MainLayout';
import Constants from './Constants';
import GetInternalRoute from './GetInternalRoute';

const App: FC = () => {
  const dispatch = useDispatch();
  const lang = i18next.language;
  useEffect(() => {
    dispatch(contentRequested(lang));
  }, [dispatch, lang]);
  return (
    <MainLayout>
      <AxiosSetup />
      <Routes>
        {GetInternalRoute(Constants.Pages.mobile)}
        {GetInternalRoute(Constants.Pages.home)}
        {GetInternalRoute(Constants.Pages.mobileChangePassword)}
        {GetInternalRoute(Constants.Pages.changePassword)}
        {GetInternalRoute(Constants.Pages.mobileChangePasswordConfirm)}
        {GetInternalRoute(Constants.Pages.changePasswordConfirm)}
        {GetInternalRoute(Constants.Pages.logOff)}
        {GetInternalRoute(Constants.Pages.loggingTest)}
        {GetInternalRoute(Constants.Pages.accessError)}
        {GetInternalRoute(Constants.Pages.mobileTimeoutError)}
        {GetInternalRoute(Constants.Pages.authorize)}
        {GetInternalRoute(Constants.Pages.afterCentralization)}
        {GetInternalRoute(Constants.Pages.authorizeCallback)}
        {GetInternalRoute(Constants.Pages.catchAll)}
      </Routes>
    </MainLayout>
  );
};

export default App;
